import { APIType } from '~/backend/types';
import { Features } from '~/components/FeatureToggle';
import {
    useBackendModels,
    useModelCustomizations,
} from '~/hooks/workflows/backend/useBackend';
import AppConfig from '~/utils/appconfig';

/**
 * Eagerly fetches AI model lists and configurations for all
 * enabled workflows so they are already in the React Query
 * cache when the user opens the AI Assistant dialog.
 *
 * Must be called from a component that mounts when session
 * data becomes available (e.g. ConnectorWorkflows).
 */
export default function useConnectorModelPrefetch() {
    const contourEnabled = AppConfig.isFeatureEnabled(
        Features.CONTOUR_WORKFLOW
    );
    const doseEnabled = AppConfig.isFeatureEnabled(Features.DOSE_WORKFLOW);
    const imageEnabled = AppConfig.isFeatureEnabled(
        Features.IMAGE_TRANSLATION_WORKFLOW
    );
    const adaptEnabled = AppConfig.isFeatureEnabled(Features.ADAPT_WORKFLOW);

    // Contour models + customizations
    useBackendModels(APIType.CONTOURING, { enabled: contourEnabled });
    useModelCustomizations(APIType.CONTOURING, { enabled: contourEnabled });

    // Dose models
    useBackendModels(APIType.DOSE, { enabled: doseEnabled });

    // Image translation models + customizations
    useBackendModels(APIType.TRANSLATION, { enabled: imageEnabled });
    useModelCustomizations(APIType.TRANSLATION, { enabled: imageEnabled });

    // Adapt (contour propagation) models
    useBackendModels(APIType.REGISTRATION, { enabled: adaptEnabled });
}
